import {ValueObject} from '@s-ui/domain'

export default class LogUserCommonValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.userID
   * @param {String} deps.token
   * @param {String} deps.isEmailConfirmed
   */
  constructor({userID: userId, token, isEmailConfirmed}) {
    super({userId, token, isEmailConfirmed})
  }
}
